<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-success mb-1">
                <i class="fa-solid fa-tag"></i>
                タグマスタ
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3 text-end">
                <button class="btn btn-outline-secondary" @click="editTag()">
                    <span class="fa-solid fa-plus"></span> 新規作成
                </button>
            </div>
            <div v-for="v in tags" :key="v.id" class="card mb-2">
                <div class="card-body d-flex align-items-center" :class="{'opacity-50': v.deleted_at}">
                    <button class="btn btn-outline-secondary me-4"
                        @click="editTag(v.id)"
                        :disabled="v.deleted_at">
                        <span class="fa-solid fa-pencil"></span>
                    </button>
                    <div class="flex-grow-1 d-flex align-items-center">
                        <span class="fs-5 fw-bold me-4">{{ v.name }}</span>
                        <span v-if="v.deleted_at" class="badge bg-danger ms-2">削除済</span>
                    </div>
                    <button class="btn ms-3"
                        @click="toggle(v)"
                        :class="{'btn-outline-danger': !v.deleted_at, 'btn-outline-success': v.deleted_at}">
                        <span class="fa-solid fa-trash-can" v-if="!v.deleted_at"> 削除</span>
                        <span class="fa-solid fa-rotate-right" v-else> 復帰</span>
                    </button>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <tag-editor
                :tag_id="tag_id"
                @saved="reload()"
                @close="closeModal"
            />
        </div>
    </div>
</template>

<script>
import TagEditor from './tagEditor.vue'
export default {
    components: { TagEditor },
    data() {
        return {
            tags: [],
            modals: [],
            tag_id: null,
        }
    },
    methods: {
        reload() {
            axios.get('/api/master/tags').then(res => {
                this.tags = res.data
            }).catch(err => {Alert.err(err)});
        },
        editTag(id = null) {
            this.tag_id = id;
            setTimeout(() => {
                this.modals['tag-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        toggle(tag) {
            let action = tag.deleted_at ? "復帰" : "削除";
            let dangerMode = !tag.deleted_at;
            let icon = tag.deleted_at ? "success" : "error";
            swal({
                title: `タグ${action}`,
                text: `指定のタグを${action}します。\nよろしいですか？`,
                icon: icon,
                dangerMode: dangerMode,
                buttons: ["キャンセル", action]
            }).then(confirm => {
                if (confirm) {
                    axios.post(`/api/master/tags/${tag.id}/toggle`).then(res => {
                        Alert.msg(res.data);
                    }).catch(err => {
                        Alert.err(err);
                    }).finally(() => this.reload());
                }
            });
        }
    },
    mounted() {
        this.modals['tag-editor'] = new bootstrap.Modal(document.getElementById('tag-editor'));
        this.reload()
    }
}
</script>
